<template>
	<div class="refund">
		<publicHeader :pageTitle="pageTitle" isWhite="true"></publicHeader>
		<!-- 占位 -->
		<div class="zhanwei"></div>
		<!-- 退费内容 -->
		<div class="refundInfo">
			<div class="refundInfoItem">
				<div class="vipName typeItem">会员名称</div>
				<div class="vipNameVal valItem">{{refundInfo.vipName}}</div>
			</div>
			<div class="refundInfoItem">
				<div class="delineTime typeItem">到期日期</div>
				<div class="delineTimeVal valItem">{{refundInfo.deadline}}</div>
			</div>
			<div class="refundInfoItem">
				<div class="residueTime typeItem">剩余时长（天）</div>
				<div class="residueTimeVa valIteml" v-if="refundInfo.remainDays <= 0 || refundInfo.remainDays == ''">0</div>
				<div class="residueTimeVa valIteml" v-else>{{refundInfo.remainDays}}</div>
			</div>
		</div>
		<!-- 退费说明 -->
		<div class="refundExplain">
			<div class="refundExplainBody">
				<div class="refundTitle">退费说明</div>
				<div class="refundExplainItem" v-for="(item,index) in refundExplainList" :key="index">
					{{item}}
				</div>
			</div>
		</div>

		<div class="refundFooter">
			<div class="refundlog" @click="gotoRefundhistory">
				<img src="https://images.zhibo.tv/2022/0328/refundLog.png" class="refundImg">
				<div class="refundFont">退费记录</div>
			</div>
			<div class="refundBtn" :class="{'unRefundBtn':noTime}" @click="gotoApplyRefund">申请退费</div>
		</div>
		<publicToast :info='info' v-show="info"></publicToast>
	</div>
</template>

<script>
	import publicHeader from '../components/PublicHeader'
	import publicToast from '../components/publicToast'
	export default {
		name: 'vipPay',
		components: {
			publicHeader,
			publicToast
		},
		data() {
			return {
				pageTitle:'',
				info: '',
				token: '',
				vipId: '',
				noTime: true,
				refundInfo: {},
				refundExplainList: [
					'1.会员退费时，优先扣除平台赠送的会员天数（例如：购买商品赠送、直播间中奖等），扣除后剩余时长，按实际支付金额折算；',
					'2.通过微信、支付宝、播币支付购买会员的，退款申请通过后，退款金额按支付方式原路退回；因支付平台限制，仅三个月内的购买记录支持线上退款；超过三个月的购买记录或使用apple支付的购买记录，需要提交收款账户，以便完成退款。',
					'3.退款申请后，预计7个工作日内处理，若有疑问，请联系客服400-801-5553（8点-20点）。'
				]
			}
		},
		created() {
			this.pageTitle = '会员退费'
			this.getToken()
			this.getRefundInfo()

		},
		methods: {
			// 跳转退费记录
			gotoRefundhistory(){
				this.$router.push(`/refundhistory?token=${this.token}&vipId=${this.vipId}`)
			},
			// 获取退款信息
			getRefundInfo() {
				const params = {
					token: this.token,
					vipId: this.vipId
				}
				this.$vipapi.getRefundInfo(params).then(res => {
					console.log('退款信息', res)
					if (res.data.data) {
						this.refundInfo = res.data.data;
						if (res.data.data.remainDays <= 0) this.noTime = true
						else this.noTime = false
					}
				})
			},
			// 跳转退费申请
			gotoApplyRefund() {
				const params = {
					token: this.token,
					vipId: this.vipId, //会员卡id
					needMoney: 1 //是否需要返回预估金额 1需要 0不需要
				}
				this.$vipapi.getRefundInfo(params).then(res => {
					console.log('含有退款预估金额会员信息', res)

					if (res.data.data.expectAccount <= 0) {
						this.info = '退款预估金额为0，无需退款'
						setTimeout(this.hideInfo,1500)
					} else {
						this.$router.push(`/applyrefund?token=${this.token}&vipId=${this.vipId}`)
					}
				})
			},
			// 隐藏toast提示
			hideInfo(){
				this.info = ''
			},
			// 获取url上的信息
			getcommit(name) {
				return (
					decodeURIComponent(
						(new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(
							location.href
						) || ['', ''])[1].replace(/\+/g, '%20')
					) || false
				)
			},
			// 获取token
			getToken() {
				if (this.$CONFIG.isVerify && this.isIOS) {
					this.token = '2a9cc326033c71cd67ac7caba01c2cd0*8028670'
				} else {
					this.token = this.getcommit('token') || ''
				}
				this.vipId = this.getcommit('vipId') || ''
				console.log(this.token)
			},
		}
	}
</script>

<style lang="less" scoped>
	.refund {
		background: #fff;

		.refundInfo {
			padding: .2rem .6rem;

			.refundInfoItem {
				height: .78rem;
				font-size: .28rem;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				display: flex;
				align-items: center;
				justify-content: space-between;

				.typeItem {
					color: #999999;
					white-space: nowrap;
				}

				.valItem {
					color: #222222;
					white-space: nowrap;
				}
			}
		}

		.refundExplain {
			padding: 0 .17rem 0 .23rem;

			.refundExplainBody {
				padding: .36rem .32rem;
				background: #F9FAFC;
				border-radius: .1rem;

				.refundTitle {
					font-size: .28rem;
					font-family: PingFangSC-Regular, PingFang SC;
					font-weight: 400;
					color: #1F1F1F;
					line-height: .4rem;
				}

				.refundExplainItem {
					margin-top: .2rem;
					font-size: .26rem;
					font-family: PingFangSC-Light, PingFang SC;
					font-weight: 300;
					color: #666666;
					line-height: .44rem;
				}
			}
		}

		.refundFooter {
			width: 100%;
			position: fixed;
			bottom: 0;
			padding: .2rem 0.4rem;
			background: #fff;
			display: flex;
			align-items: center;
			justify-content: space-between;
			box-sizing: border-box;

			.refundBtn {
				width: 5.42rem;
				height: .96rem;
				background: linear-gradient(145deg, #F5E4D3 0%, #C4A485 100%);
				border-radius: .48rem;
				font-size: .32rem;
				font-family: PingFangSC-Medium, PingFang SC;
				font-weight: 500;
				color: #613F25;
				display: flex;
				align-items: center;
				justify-content: center;
			}

			.unRefundBtn {
				background: #F7F8FC;
				color: #666666;
			}

			.refundFont {
				margin-top: .1rem;
				font-size: .22rem;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #613F25;
				line-height: .3rem;
			}

			.refundImg {
				width: .48rem;
				height: .48rem;
				display: block;
				margin: auto;
			}
		}
	}
</style>
